<template>
  <Select
    size="large"
    :options="options"
    placeholder="请选择学院"
    @change="onChange"
    allowClear
    :loading="loading"
  ></Select>
</template>
<script setup lang="ts">
import { Select } from 'ant-design-vue'
import { onMounted, ref } from 'vue'
import { getFacultyList } from '@/api/web'

const options = ref<{ label: string; value: string }[]>()

const loading = ref(false)
onMounted(() => {
  loading.value = true
  getFacultyList({})
    .then((response) => {
      options.value = response.data.map((i) => ({
        label: i.name,
        value: i.name,
      }))
    })
    .finally(() => {
      loading.value = false
    })
})

const emit = defineEmits(['input'])
function onChange(val: string) {
  emit('input', val)
}
</script>
<style lang="less" scoped></style>
